import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Workspace from "@/pages/Workspace";
import Presentation from "@/pages/Presentation";
import Utbildning from "@/pages/Utbildning";
import Svara from "@/pages/Svara";
import Undersokning from "@/pages/Undersokning";
import Mote from "@/pages/Mote";
import Insamling from "@/pages/Insamling";
import ConsultantHub from "@/pages/ConsultantHub";
import Overview from "@/pages/Overview";
import RoleAgents from "@/pages/RoleAgents";
import RoleAgentPortal from "@/pages/RoleAgentPortal";

function Protected({ children }) {
    const { user } = useAuth();
    if (user === undefined) {
        return (
            <div className="min-h-screen bg-abyss flex items-center justify-center">
                <div className="font-mono text-xs uppercase tracking-widest text-slate-500 animate-pulse">
                    Laddar HAMN ATLAS …
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function PresentationRedirect() {
    const { projectId } = useParams();
    return <Navigate to={`/view/${projectId}`} replace />;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/svara/:token" element={<Svara />} />
                    <Route path="/undersokning/:token" element={<Undersokning />} />
                    <Route path="/mote/:token" element={<Mote />} />
                    <Route path="/insamling/:token" element={<Insamling />} />
                    <Route path="/rollagent" element={<RoleAgentPortal />} />
                    <Route path="/rollagent/:token" element={<RoleAgentPortal />} />
                    <Route path="/" element={<Protected><Overview /></Protected>} />
                    <Route path="/karta" element={<Protected><Workspace /></Protected>} />
                    <Route path="/view/:projectId" element={<Protected><Presentation /></Protected>} />
                    <Route path="/presentation/:projectId" element={<Protected><PresentationRedirect /></Protected>} />
                    <Route path="/utbildning" element={<Protected><Utbildning /></Protected>} />
                    <Route path="/hub" element={<Protected><ConsultantHub /></Protected>} />
                    <Route path="/rollspegling/:projectId" element={<Protected><RoleAgents /></Protected>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="bottom-right" />
        </AuthProvider>
    );
}

export default App;
